import uuid from 'short-unique-id';

export const UUID = new uuid({ length: 6, dictionary: 'number' });